import { render, staticRenderFns } from "./MenCard.vue?vue&type=template&id=19b49c48&"
import script from "./MenCard.vue?vue&type=script&lang=js&"
export * from "./MenCard.vue?vue&type=script&lang=js&"
import style0 from "./MenCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports